import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss']
})
export class SwitchComponent extends ComponentBase implements OnInit {

  constructor() { super() }

  ngOnInit() {
  }
}
